/**
 * Create a strong reference to the given value.
 * @param value - the value to wrap in a strong reference
 * @returns the strong reference containing the value
 */
export function CreateStrongRef(value) {
    return { value };
}
//# sourceMappingURL=strongRef.js.map